export default "__VITE_ASSET__acdd2c67__"